/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgNoEdit = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.117 34.627 13.295-13.258.002-2.83L45.461 7.586l-2.826-.002-13.299 13.262 2.829 2.828 11.88-11.847 8.124 8.124-11.88 11.847 2.828 2.829Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.332 26.499-.002.003 8.124 8.123.002-.002 2.829 2.828-.003.003 16.132 16.132-2.828 2.828L37.45 40.278 25.038 52.655l-1.015.544-13.626 2.761-2.36-2.343 2.674-13.713.55-1.033L23.67 26.498 7.586 10.414l2.828-2.828 16.087 16.087.003-.003 2.828 2.829ZM14.52 41.27l-1.984 10.175 10.103-2.048L34.621 37.45l-8.124-8.124L14.52 41.271Z",
  clipRule: "evenodd"
}));

export default SvgNoEdit;